import React, { useState } from 'react';
import projectsData from '../Data/Data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

const Works = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const openModal = (project) => {
    setSelectedProject(project);
  };

  const closeAndResetModal = () => {
    setSelectedProject(null);
  };

  const sortedProjects = [...projectsData].sort((a, b) => b.id - a.id);

  return (
    <section className="work" id="work">
      <div className="content">
        {sortedProjects.map((project) => (
          <div className='card reveal' key={project.id}>
            <h3>{project.title}</h3>
            <div className="card-img" onClick={() => openModal(project)}>
              <img src={process.env.PUBLIC_URL + project.image} alt={project.title} />
            </div>
            <div className='button-card'>
              {project.websitelink ? (
                <a className="button" href={project.websitelink} target="_blank" rel="noopener noreferrer" aria-label={`Visitez ${project.title}`}>
                  <FontAwesomeIcon className="iconfontawesome iconwork" icon={faGlobe} />
                </a>
              ) : null}
              <a className="button" href={project.githublink} target="_blank" rel="noopener noreferrer" aria-label={`Profil GitHub de ${project.title}`}>
                <FontAwesomeIcon className="iconfontawesome iconwork" icon={faGithub} />
              </a>
            </div>
          </div>
        ))}
      </div>
      {selectedProject && (
        <div className={`modal ${selectedProject ? 'show' : ''}`} onClick={closeAndResetModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedProject.title}</h2>
            <img src={process.env.PUBLIC_URL + selectedProject.image} alt={selectedProject.title} />
            <p>{selectedProject.description}</p>
            <div className="skills-icons">
              {selectedProject.skills.map((icon, index) => (
                <FontAwesomeIcon key={index} className="iconfontawesome" icon={icon} />
              ))}
            </div>
            <div className='button-card button-modal'>
              {selectedProject.websitelink ? (
                <a className="button" href={selectedProject.websitelink} target="_blank" rel="noopener noreferrer" aria-label={`Visitez ${selectedProject.title}`}>
                  Visiter le site web
                </a>
              ) : null}
              <a className="button" href={selectedProject.githublink} target="_blank" rel="noopener noreferrer" aria-label={`Profil GitHub de ${selectedProject.title}`}>
                Voir le code
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Works;
